import { useEffect, useState } from "react";
import * as THREE from "three";

import { RegisterStatePositionObserver, RegisterStateObserver } from "Interfaces/StateInterface.js";

import "./style.css";

import TxtScreen2 from "Assets/txt_screen2.png";

export default function Screen2(){

    const [imageWidth, setImageWidth] = useState("100%");
    const [offsetX, setOffsetX] = useState("0px");
    const [offsetY, setOffsetY] = useState("0px");
    const [display, setDisplay] = useState("none");
    const [opacity, setOpacity] = useState(0);

    const pointPosition = new THREE.Vector3(1.35, 0.8, 13.5);

    function CalculatePosition(camera, proportion){        
        const screenPosition = pointPosition.clone();        
        screenPosition.project(camera);
        setOffsetX(((((1 + screenPosition.x) / 2) * window.innerWidth) - (187 * proportion)) + "px");
        setOffsetY(((((1 + -screenPosition.y) / 2) * window.innerHeight) - (187 * proportion)) + "px");
    }

    function ShowElement(){
        setDisplay("block");
        setTimeout(() => {
            setOpacity(1); 
        }, 1000);
    }

    function HideElement(){
        setOpacity(0);
        setTimeout(() => {
            setDisplay("none");
        }, 1500);
        
    }

    useEffect(() => {
        window.addEventListener('resize', () => {    
            setImageWidth((window.innerWidth * 0.35) + "px");
        });        
        setImageWidth((window.innerWidth * 0.35) + "px"); 
        
        RegisterStatePositionObserver("screen1", CalculatePosition);
        RegisterStatePositionObserver("screen2", CalculatePosition);
        RegisterStatePositionObserver("screen3", CalculatePosition);
        RegisterStateObserver("screen1", HideElement);
        RegisterStateObserver("screen2", ShowElement);
        RegisterStateObserver("screen3", HideElement);
    }, []);

    return (
        <div className="screen2" id="screen2" style={{ width: imageWidth, top: offsetY, left: offsetX, display: display, opacity: opacity }}  >
            <img alt="" src={TxtScreen2} />
        </div>
    )
}